// extracted by mini-css-extract-plugin
export default {"optionBlock":"ebcvE0ITbCLZufZzb1Um","deactivated":"GZ9bAlCX4wybfXcVHgN4"};